/* APP
=================================================== */

var APP = (function()
{
	/* init
	--------------------------------------------- */

	var _init = function()
	{
		$('#overlay-section').on('click', function( e )
		{
			if( $(e.target).closest('.content').length == 0 )
			{
				_info_close();

				return false;
			}
		});

		$('#video-overlay').on('click', function( e )
		{
			if( $(e.target).closest('.content').length == 0 )
			{
				_video_close();

				return false;
			}
		});

		$('.floater-field input, .floater-field textarea').on('keyup', function()
		{
			if( $(this).val() != '' )
			{
				$(this).parent().addClass('floated');
			}
			else
			{
				$(this).parent().removeClass('floated');
			}
		});

		autosize($('textarea.autosize'));


		$('.videos-slider').slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1,
			variableWidth: false,
			nextArrow: '<button type="button" class="slick-next"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="22.667"><path fill="#010101" d="M2.623 0L0 2.623l8.62 8.618L0 19.859l2.623 2.623 11.241-11.241L2.623 0z"/></svg></span></button>',
			prevArrow: '',
			responsive:
			[
				{
					breakpoint: 767,
					settings:
					{
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

    // Dark Site Modal Warning Close Button
    // ----------------------------------------------------------------------------
    $('#closeModal').on('click', function(e){
      $('#wrapModal').remove();
    });
	}; // function _init

	/* _menu_open
	--------------------------------------------- */

	var _menu_open = function( that )
	{
		$('body').addClass('menu-open');
		window.scrollTo(0, 0);
	};

	/* _menu_close
	--------------------------------------------- */

	var _menu_close = function( that )
	{
		$('body').removeClass('menu-open');
		window.scrollTo(0, 0);
	};


	/* _search_open
	--------------------------------------------- */

	var _search_open = function( that )
	{
		$('body').addClass('search-open');
		window.scrollTo(0, 0);

		setTimeout(function()
		{
			$('#search-menu .search-field').focus();
		}, 200 );
	};

	/* _search_close
	--------------------------------------------- */

	var _search_close = function( that )
	{
		$('body').removeClass('search-open');
		window.scrollTo(0, 0);
		$('#search-menu .search-field').blur();
	};


	/* _video_popup
	--------------------------------------------- */

	var _video_popup = function( embed_url, controls )
	{
		$('#video-overlay').addClass('open');

		controls = ( controls )? '1' : '0';

		$('#video-overlay .video-embed').html('<iframe src="'+embed_url+'?controls='+controls+'&modestbranding=1&rel=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>');
	};


	/* _video_close
	--------------------------------------------- */

	var _video_close = function()
	{
		$('#video-overlay').removeClass('open');
		$('#video-overlay .video-embed').html('');
	};


	/* _video_inline
	--------------------------------------------- */

	var _video_inline = function( that, embed_url )
	{
		$(that).addClass('playing');
		$(that).find('.video').html('<iframe src="'+embed_url+'?controls=0&modestbranding=1&rel=0&showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>');
	};


	/* _faq_toggle
	--------------------------------------------- */

	var _faq_toggle = function( that )
	{
		$(that).closest('.entry').toggleClass('open');
	};

  /* validateEmail
  --------------------------------------------- */
  var _validateEmail = function(ev, that) {
    var $that = $(that);
    var val = $that.val();
    
    if (!val) { return; }
    
    var emailFilter = /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i;

    if (emailFilter.test(val)) {
      $that.closest('.field').removeClass('error');
    }
    else {
      $that.closest('.field').addClass('error');
    }
  };

  /**
   * Tracks a link click, then sends the user to the target location.
   * Gotta do this in two steps, because otherwise the link click takes precedence and
   * the event is never sent.
   * 
   * @return false so you can `return trackOutboundLink(..)` from onclick handlers
   */
  function trackOutboundLink(url, eventType) {
    if (!window.gtag) { return true; }
    
    var fnGoToUrl = function() { document.location = url;};
    eventType = eventType || 'click';

    gtag('event', eventType, {
      'event_label' : url,
      'event_callback': fnGoToUrl
    });
    
    window.setTimeout(fnGoToUrl, 1000);
    return false;
  }

	/* public
	--------------------------------------------- */

	return {
		init: _init,
		video_popup: _video_popup,
		video_inline: _video_inline,
		menu_open: _menu_open,
		menu_close: _menu_close,
		search_open: _search_open,
		search_close: _search_close,
		faq_toggle: _faq_toggle,
		trackOutboundLink: trackOutboundLink,
    validateEmail: _validateEmail
	};


})();

window.APP = APP;
